export default {
  WeChat_ReturnUrl: window ? window.location.origin : 'http://dev.encmobile.com'
}
